import React from 'react';
import {Heading, Stack} from '@chakra-ui/react';
import {templateSettings} from 'anvil_settings/template_settings';
import {RichText} from "frontend/wagtail/components/RichText";

/**
 * Component to display the "account_help_box_text" template setting during account creation in the order tunnel.
 *
 * @returns {JSX.Element|null}
 * @constructor
 */
export const AccountHelpBox = () => {

    const accountHelp = templateSettings.account_help_box_text_serialized;

    // If no account_help_box_text is configured, don't render anything.
    if (accountHelp === undefined || accountHelp.length < 1) {
        return null;
    }

    return (
        <Stack layerStyle={'aside'}>
            {accountHelp.map((field, index) => {  // Anvil allows multiple heading & paragraph blocks. This works for that.
                if (field.type === "heading") {
                    return <Heading fontSize={"lg"} key={index}>{field.value}</Heading>;
                }

                if (field.type === "paragraph") {
                    return <RichText key={index} data={field.value}/>;
                }
            })}
        </Stack>
    );
};
